import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const cMPlatformsApi = createApi({
  reducerPath: 'cMPlatformsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Platforms'],
  endpoints: (builder) => ({
    listCampaignsPlatform: builder.query({
      query: (params) => ({
        url: `/campaigns/platforms/`,
        params,
      }),
      providesTags: ['Platforms'],
      
    }),

    createCampaignsPlatform: builder.mutation({
      query: (data) => ({
        url: `/campaigns/platforms/`,
        method: 'POST',
        body: data,
      }),
      providesTags: ['Platforms'],
    }),

    updateCampaignsPlatform: builder.mutation({
      query: ({ id, data }) => ({
        url: `/campaigns/platforms/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      providesTags: ['Platforms'],
    }),

    deleteCampaignsPlatform: builder.mutation({
      query: (id) => ({
        url: `/campaigns/platforms/${id}/`,
        method: 'DELETE',
      }),
      providesTags: ['Platforms'],
    }),
  }),
});

export const {
  useListCampaignsPlatformQuery,
  useCreateCampaignsPlatformMutation,
  useUpdateCampaignsPlatformMutation,
  useDeleteCampaignsPlatformMutation,
} = cMPlatformsApi;
